let NEW_DOCUMENT_TEMPLATE_TABLE = /* HTML */ ` <table
  style="border-collapse: collapse; height: 10px;"
  cellspacing="20"
>
  <thead>
    <tr>
      <th style="text-align: left;"></th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td style="width: 770px; text-align: left; line-height: 1;">
        {{CONTENT}}
      </td>
    </tr>
  </tbody>
  <tfoot>
    <tr>
      <td style="text-align: left;"></td>
    </tr>
  </tfoot>
</table>`

export function getNewDocumentTemplateTable(content = '') {
  return NEW_DOCUMENT_TEMPLATE_TABLE.replace('{{CONTENT}}', content)
}
